import PropTypes from 'prop-types'
import React from 'react'
import { getApiServiceUrlEnvironmentUtil } from 'modules/environment/utils'
import { getObjectUtil } from 'packages/src'

function StaticPopup ({
  title,
  url,
  width = 640,
  height = 480,
  onMessage = null
}) {
  const popupRef = React.useRef(null)

  React.useEffect(() => {
    // Open popup on mount
    const left = (window.screen.width / 2) - (width / 2)
    const top = (window.screen.height / 2) - (height / 2)
    const windowOptions = `scrollbars=yes, width=${width} height=${height} top=${top}, left=${left}`
    popupRef.current = window.open(url, title, windowOptions)

    // Puts focus on the popup
    if (getObjectUtil(popupRef.current, 'focus')) {
      popupRef.current.focus()
    }

    // Handle messages from popup
    const handleMessage = (event) => {
      if (getApiServiceUrlEnvironmentUtil().indexOf(event.origin) === -1) {
        console.error(
          'onMessage: [ERROR] message posted from a different origin %o',
          event.origin
        )
        return
      }
      if (onMessage) {
        onMessage(event.data, popupRef.current)
      }
    }

    window.addEventListener('message', handleMessage)

    // Cleanup on unmount
    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [title, url, width, height, onMessage])

  return null
}

StaticPopup.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  onMessage: PropTypes.func
}

export default StaticPopup
